import { useTranslation } from 'react-i18next';
import { Button } from '../../../../styled-components/components/Button';
import Loader from '../../../../styled-components/components/Loader';
import { ShallowPanelFooter } from '../../../../styled-components/components/Panel/ShallowPanel';
import {
  FooterAction,
  FooterActionItem,
} from '../../../../styled-components/components/Panel/wrapper';

interface CreateVehicleFooterProps {
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const CreateVehicleFooter = ({
  onClose,
  onSubmit,
  loading,
  disabled,
}: CreateVehicleFooterProps) => {
  const { t } = useTranslation(['common', 'createVehiclePanel']);

  return (
    <ShallowPanelFooter>
      <FooterAction>
        <FooterActionItem>
          <Button onClick={() => onClose()} $tone="secondary">
            {t('cancel', { ns: 'common' })}
          </Button>
        </FooterActionItem>
        <FooterActionItem>
          <Button onClick={() => onSubmit()} $tone="primary" disabled={disabled || loading}>
            {t('addVehicle', { ns: 'createVehiclePanel' })}
            {loading && <Loader inline />}
          </Button>
        </FooterActionItem>
      </FooterAction>
    </ShallowPanelFooter>
  );
};
